export const TEMPLATE = {
  OFFER: 'offer',
}
